//@flow
import { compose } from 'react-recompose';
import { withNavigationFocus } from '@react-navigation/compat';
import { connect } from 'react-redux';
import { change as changeFormFieldValue, submit as submitForm } from 'redux-form';
import SIMCardScan from './SIMCardScan';

const mapDispatchToProps = {
  changeFormFieldValue,
  submitForm,
};

export default compose(withNavigationFocus, connect(null, mapDispatchToProps))(SIMCardScan);
